import { Route, Routes } from "react-router-dom";
import Organizations from "./Organizations";

export default function OrganizationsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Organizations />} />
    </Routes>
  );
}
